import Base from '../base.js'
import { statusResponse } from '../responseService'
export default class Category extends Base {
  constructor () {
    super('/categories')
  }

  listCategory = () => {
    return new Promise((resolve, reject) => {
      this.http.get(this.api).then((response) => {
        resolve(response)
      }).catch((err) => {
        reject(statusResponse(err, 'list'))
      })
    })
  }
}
